"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var ImagePicker_1 = require("./ImagePicker");

exports.ImagePickerWithForm = function (_a) {
  var collection = _a.collection,
      initialSelectedId = _a.initialSelectedId,
      name = _a.name,
      setFieldValue = _a.setFieldValue,
      values = _a.values,
      isSubmitting = _a.isSubmitting;
  return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
    var activeBreakpoint = _a.activeBreakpoint,
        width = _a.width;
    return react_1.default.createElement(ImagePicker_1.ImagePicker, {
      collection: collection,
      initialSelectedId: initialSelectedId,
      activeBreakpoint: activeBreakpoint,
      screenWidth: width,
      isDisabled: isSubmitting
    }, function (value) {
      var prevValue = values[name];
      if (prevValue !== value && value) setFieldValue(name, value);
      return null;
    });
  });
};